"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const traceLogomark_styles_1 = __importDefault(require("./traceLogomark.styles"));
class TraceLogomark extends react_1.Component {
    constructor() {
        super(...arguments);
        this.id = lodash_uniqueid_1.default('lm_');
        this.render = () => {
            const { classes } = this.props;
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 84", "aria-hidden": "true", className: classes.root }, { children: [jsx_runtime_1.jsxs("clipPath", Object.assign({ id: this.id }, { children: [jsx_runtime_1.jsx("rect", { x: "0", y: "0", width: "25.7", height: "46.3", rx: "3.9", ry: "3.9" }, void 0),
                            jsx_runtime_1.jsx("rect", { x: "37.2", y: "0", width: "25.7", height: "84", rx: "3.9", ry: "3.9" }, void 0),
                            jsx_runtime_1.jsx("rect", { x: "74.3", y: "0", width: "25.7", height: "65.3", rx: "3.9", ry: "3.9" }, void 0)] }), void 0),
                    jsx_runtime_1.jsxs("g", Object.assign({ clipPath: `url(#${this.id})`, className: classes.bands }, { children: [jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "245.65" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "228.5" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "211.3" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "194.1" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "176.95" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "159.75" }, void 0)] }), void 0)] }), void 0));
        };
    }
}
TraceLogomark.propTypes = {
    classes: prop_types_1.default.object.isRequired
};
exports.default = react_jss_1.default(traceLogomark_styles_1.default)(TraceLogomark);
//# sourceMappingURL=index.js.map